import React from "react";
import FormContext, { IFormContext } from "src/context/FormContext";
import envConfig from "src/envConfig/envHelper";

const isFormContextEnabled = envConfig.windowRuntime?.formContext;

declare global {
  interface Window {
    FormContext?: IFormContext;
  }
}

export const ExposeFormContext: React.FC = () => {
  const formContext = React.useContext(FormContext);
  React.useEffect(() => {
    if (isFormContextEnabled) {
      window.FormContext = formContext;
    }
    return () => {
      delete window.FormContext;
    };
  }, [formContext]);
  return <></>;
};
